import { __read, __spreadArray, __assign } from 'tslib';
import Cookie from 'js-cookie';
import { v4 } from 'uuid';

var allowedParams = ['source', 'medium', 'campaign', 'term', 'content'];
function storeUTMParams(params) {
    var cookieDomain = getState().settings.cookieDomain;
    Object.entries(params).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        window.sessionStorage.setItem("se_utm_".concat(key), value);
        Cookie.set("se_utm_".concat(key), value, {
            domain: cookieDomain,
        });
    });
}
function extractUTMFromLocation(inputUrl) {
    if (inputUrl === void 0) { inputUrl = window.location.href; }
    var url = new URL(inputUrl);
    var params = {};
    url.searchParams.forEach(function (value, key) {
        var _a = __read(key.split('_'), 2), prefix = _a[0], paramName = _a[1];
        if (prefix === 'utm' && allowedParams.includes(paramName)) {
            params[paramName] = value;
        }
    });
    return params;
}
function extractUTMFromStorage() {
    return allowedParams.reduce(function (acc, param) {
        var sessionStorageValue = sessionStorage.getItem("se_utm_".concat(param));
        if (sessionStorageValue) {
            acc[param] = sessionStorageValue;
        }
        return acc;
    }, {});
}

var state = {
    heartbeat: null,
    session: {
        channelId: '',
        sessionId: '',
        profileId: '',
        roleplayId: '',
        anonymousUserId: '',
    },
    settings: {
        environment: 'production',
        cookieDomain: typeof location === 'undefined' ? '' : location.hostname,
        cookieName: 'se-science-id',
        anonymousUserIdCookieName: 'se-science-anonymous-user-id',
        isDebugMode: typeof location === 'undefined' ? false : location.search.slice(1).split('&').includes('science-debug=1'),
    },
    utm: {},
    contextFields: new Map(),
    contextParams: {},
};
/**
 * @ignore
 * Sets new session (doesn't mutate current)
 * @param session - Full session object
 */
function setSession(session) {
    for (var key in state.session) {
        if (typeof session[key] === 'undefined') {
            throw new Error("You must provide all fields to set session: ".concat(key));
        }
    }
    state.session = __assign(__assign({}, state.session), session);
}
/**
 * @ignore
 * Creates a new settings object, overriding the current values with the provided
 * @param settings - Partial settings object
 */
function setSettings(settings) {
    state.settings = __assign(__assign({}, state.settings), settings);
}
function setUTMParams(params) {
    state.utm = __assign(__assign({}, state.utm), params);
    storeUTMParams(state.utm);
}
/** Add context fields to be sent with every event */
function addContextFields(fields) {
    state.contextFields = new Map(__spreadArray(__spreadArray([], __read(state.contextFields.entries()), false), __read(Object.entries(fields)), false));
}
/**
 * Remove context fields which were previously added
 */
function removeContextFields(keys) {
    keys.forEach(function (key) { return state.contextFields.delete(key); });
}
/**
 * @ignore
 * Returns a new state object
 */
function getState() {
    return __assign({}, state);
}
function setState(s) {
    var _a = s.heartbeat, heartbeat = _a === void 0 ? state.heartbeat : _a;
    Object.assign(state, {
        heartbeat: heartbeat,
    });
}
/** set context params to be sent with every event */
function addContextParams(params) {
    Object.assign(state.contextParams, params);
}

var style = "\n.se-science-toasts {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  padding: 8px;\n  max-width: 300px;\n  z-index: 61;\n}\n\n.se-science-toast {\n  display: inline-block;\n  max-width: 350px;\n  background-color: white;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  box-shadow: 0 12px 25px 0px hsla(0, 0%, 0%, 0.1);\n  color: hsl(150, 50, 25%);\n  font-family: system-ui, sans-serif;\n  margin-bottom: 8px;\n}\n\n.se-science-toast-content {\n  padding: 12px;\n}\n\n.se-science-toast p {\n  margin: 0 0.25em 2px;\n  font-size: 12px;\n  display: inline-block;\n  color: hsl(0, 0%, 30%);\n}\n\n.se-science-toast-event-name {\n  font-size: 14px;\n  margin-bottom: 6px;\n  font-weight: bold;\n  display: block;\n  color: hsl(250, 70%, 60%);\n}\n\n.se-science-toast-fields {\n  display: block;\n  margin-bottom: 0;\n}\n\n.se-science-toast-progress {\n  display: block;\n  width: 100%;\n  height: 4px;\n  background-color: hsl(250, 60%, 90%);\n}\n\n@keyframes se-science-toast-progress {\n  to {\n    width: 0%;\n  }\n}\n\n.se-science-toast-progress span {\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-color: hsla(250, 60%, 40%, 0.5);\n  animation: se-science-toast-progress 8s 1 linear;\n}\n";

var WRAPPER_DOM_ID = 'se-science-toasts-root';
var TOAST_DOM_CLASS = 'se-science-toast';
var WRAPPER_NODE = typeof document === 'undefined' ? null : document.getElementById(WRAPPER_DOM_ID);
function createWrapper() {
    var div = document.createElement('div');
    div.setAttribute('id', WRAPPER_DOM_ID);
    div.classList.add('se-science-toasts');
    var styleEl = document.createElement('style');
    styleEl.innerHTML = style;
    document.head.append(styleEl);
    document.body.append(div);
    WRAPPER_NODE = div;
}
function getWrapper() {
    if (!WRAPPER_NODE) {
        createWrapper();
    }
    return WRAPPER_NODE;
}
function setDebugMode(isOn) {
    if (isOn === void 0) { isOn = true; }
    setSettings({
        isDebugMode: isOn,
    });
}
function createToastTextNode(label, value, className) {
    if (!value) {
        return '';
    }
    return "<p class=\"se-science-toast-".concat(className, "\">").concat(label, ": ").concat(value, "</p>");
}
function createToastElement(_a) {
    var name = _a.name, product = _a.product, _b = _a.feature, feature = _b === void 0 ? '' : _b, placement = _a.placement, source = _a.source, type = _a.type, _c = _a.fields, fields = _c === void 0 ? [] : _c;
    var toast = document.createElement('div');
    toast.classList.add(TOAST_DOM_CLASS);
    var nodes = [
        ['Product', product || '', 'product'],
        ['Feature', feature, 'feature'],
        ['Placement', placement, 'feature'],
        ['Source', source],
        ['Type', type],
        ['Fields', fields.length ? "[ ".concat(fields.map(function (f) { return f.join(':'); }).join(',\n'), " ]") : '', 'feature'],
    ]
        .filter(function (_a) {
        var _b = __read(_a, 2); _b[0]; var value = _b[1];
        return !!value;
    })
        .map(function (_a) {
        var _b = __read(_a, 3), label = _b[0], value = _b[1], _c = _b[2], className = _c === void 0 ? 'feature' : _c;
        return createToastTextNode(label, value, className);
    });
    toast.innerHTML = "\n  <div class=\"se-science-toast-content\">\n    <p class=\"se-science-toast-event-name\">".concat(name, "</p>\n    ").concat(nodes, "\n  </div>\n\n  <div class=\"se-science-toast-progress\">\n    <span></span>\n  </div>\n  ");
    return toast;
}
function showDebugToast(evt) {
    var wrapper = getWrapper();
    var toast = createToastElement(evt);
    wrapper.append(toast);
    window.setTimeout(function () {
        wrapper.removeChild(toast);
    }, 8000);
}

var config = {
    production: {
        heartbeat: {
            base: 'https://api.streamelements.com/heartbeat',
            get uri() {
                return this.base;
            },
        },
        science: {
            base: 'https://api.streamelements.com/science',
            version: 'v1',
            get uri() {
                return this.base;
            },
        },
    },
    staging: {
        heartbeat: {
            base: 'https://api.staging.streamelements.com/heartbeat',
            get uri() {
                return this.base;
            },
        },
        science: {
            base: 'https://api.staging.streamelements.com/science',
            version: 'v1',
            get uri() {
                return this.base;
            },
        },
    },
    development: {
        heartbeat: {
            base: 'https://api.staging.streamelements.com/heartbeat',
            get uri() {
                return this.base;
            },
        },
        science: {
            base: 'http://localhost:4069/v1',
            version: 'v1',
            get uri() {
                return "".concat(this.base, "/").concat(this.version);
            },
        },
    },
};
function getConfig() {
    var settings = getState().settings;
    if (!(settings.environment in config)) {
        throw new Error('Invalid environment');
    }
    return config[settings.environment];
}

/**
 * Creates an anonymous user id if it doesn't exist (or force == true),
 * stores it into a cookie and updates the session data.
 * @return - the anonymous user id
 */
function anonymize(force) {
    if (force === void 0) { force = false; }
    var _a = getState(), session = _a.session, settings = _a.settings;
    var anonymousUserId = Cookie.get(settings.anonymousUserIdCookieName);
    if (!anonymousUserId || force) {
        anonymousUserId = v4();
        Cookie.set(settings.anonymousUserIdCookieName, anonymousUserId, {
            expires: 365 * 100,
            domain: settings.cookieDomain,
        });
    }
    setSession(__assign(__assign({}, session), { anonymousUserId: anonymousUserId }));
    return anonymousUserId;
}

var beats = 0;
var minute = 60 * 1000;
var beatRates = [
    {
        condition: minute * 10,
        rate: minute / 2, // Every 30 seconds for 10 minutes
    },
    {
        condition: minute * 60,
        rate: minute, // Every minute for an hour
    },
    {
        condition: Infinity,
        rate: minute * 10, // Every 10 minutes
    },
];
var currentRateIndex = 0;
var currentRate = beatRates[currentRateIndex];
/**
 * Stops the pulsing heartbeat initiated with pulse()
 */
function stopPulsing() {
    var _a;
    var state = getState();
    window.clearInterval((_a = state.heartbeat) !== null && _a !== void 0 ? _a : undefined);
    setState({ heartbeat: null });
    beats = 0;
}
function sendPulse() {
    var _a = getState(), session = _a.session; _a.settings;
    var sessionId = session.sessionId;
    if (!sessionId) {
        return;
    }
    beats++;
    var config = getConfig();
    window.fetch(config.heartbeat.uri, {
        method: 'POST',
        body: JSON.stringify({
            sessionId: sessionId,
            timestamp: new Date().toISOString(),
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    // Back off after a set number of minutes.
    if (beats * currentRate.rate > currentRate.condition) {
        stopPulsing();
        currentRateIndex++;
        currentRate = beatRates[currentRateIndex];
        pulse();
    }
}
/**
 * Starts up a heartbeat that sends out network requests
 * to notify our systems that a session is alive.
 */
function pulse() {
    stopPulsing();
    sendPulse();
    var heartbeat = window.setInterval(sendPulse, currentRate.rate);
    setState({ heartbeat: heartbeat });
}
/**
 * Initializes the lab.
 * @returns string - The session id
 */
function init(settings) {
    if (settings === void 0) { settings = {}; }
    setSettings(settings);
    setUTMParams(__assign(__assign({}, extractUTMFromStorage()), extractUTMFromLocation(window.location.href)));
    var _a = getState().settings, cookieDomain = _a.cookieDomain, cookieName = _a.cookieName;
    // Fetch potential session id to tie to a logged-in user
    var sessionId = Cookie.get(cookieName);
    if (!sessionId) {
        sessionId = v4();
        // Will expire on tab close
        Cookie.set(cookieName, sessionId, {
            domain: cookieDomain,
        });
    }
    // create anonymous user id if it doesn't exist
    anonymize();
    var currentState = getState();
    setSession(__assign(__assign({}, currentState.session), { sessionId: sessionId }));
    if (currentState.settings.isDebugMode) {
        showDebugToast({
            product: 'dashboard',
            name: 'Alchemy Debug-mode: ON',
            feature: '',
            referer: '',
        });
    }
    return sessionId;
}

/**
 * Identifies a user
 */
function identify(params) {
    var channelId = params.channelId, _a = params.profileId, profileId = _a === void 0 ? channelId : _a, _b = params.roleplayId, roleplayId = _b === void 0 ? '' : _b;
    setSession(__assign(__assign({}, getState().session), { roleplayId: roleplayId, channelId: channelId, profileId: profileId }));
}

/**
 * Returns location.host + location.pathname
 * @internal
 */
function getDefaultReferer() {
    return "".concat(window.location.host).concat(window.location.pathname);
}
/**
 * @internal
 */
function getSessionKeysDebugString(session) {
    return Object.keys(session)
        .map(function (k) { return "".concat(k, ": ").concat(session[k]); })
        .join('\n');
}
function stringToSnakeCase(input) {
    if (input === void 0) { input = ''; }
    var matches = input.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g);
    if (!matches)
        return '';
    return matches.map(function (c) { return c.toLowerCase(); }).join('_');
}
/**
 * Sends a science event
 */
function track(params) {
    var _a;
    var product = params.product, feature = params.feature, name = params.name, _b = params.fields, fields = _b === void 0 ? [] : _b, placement = params.placement, type = params.type, source = params.source, _c = params.prefix, prefix = _c === void 0 ? '' : _c;
    if (!product || !feature || !name) {
        throw new Error('Invalid parameters specified to "track"; Missing one product, feature or event name');
    }
    var state = getState();
    if (!state.session.sessionId) {
        var resp = new Response();
        resp.sentToTheVoid = true;
        return Promise.resolve(resp);
    }
    if (state.settings.isDebugMode) {
        console.info([
            "SE SCIENCE: ".concat(name),
            getSessionKeysDebugString(state.session),
            "product: ".concat(product),
            "feature: ".concat(feature),
            "placement: ".concat(placement),
            "product: ".concat(product),
            "type: ".concat(type),
            "source: ".concat(source),
            "prefix: ".concat(prefix),
            "fields: ".concat(fields.map(function (pair) { return pair.join(':'); }).join(',\n')),
        ].join('\n'));
        showDebugToast(params);
    }
    /**
     * if CF zaraz is present, push an event to it as well
     * https://developers.cloudflare.com/zaraz/
     */
    try {
        var zarazPayload = createZarazPayload(params, state);
        (_a = window.zaraz) === null || _a === void 0 ? void 0 : _a.track(name, zarazPayload);
    }
    catch (err) {
        // tslint:disable-next-line:no-console
        console.error(err);
    }
    var config = getConfig();
    var sciencePayload = createSciencePayload(params, state);
    return window.fetch("".concat(state.settings.proxy || config.science.uri, "/insert/").concat(product), {
        body: JSON.stringify(sciencePayload),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    });
}
function arrToObject(arr, prefix) {
    return Object.fromEntries(arr.map(function (item) { return ["".concat(prefix).concat(item), true]; }));
}
function createSciencePayload(params, state) {
    var session = state.session, utm = state.utm, contextFields = state.contextFields, contextParams = state.contextParams;
    var _a = __assign(__assign({}, contextParams), params), feature = _a.feature, name = _a.name, _b = _a.fields, fields = _b === void 0 ? [] : _b, placement = _a.placement, type = _a.type, source = _a.source, _c = _a.referer, referer = _c === void 0 ? getDefaultReferer() : _c, _d = _a.prefix, prefix = _d === void 0 ? '' : _d, amount = _a.amount, count = _a.count, items = _a.items, message = _a.message, channelStats = _a.channelStats, featureFlags = _a.featureFlags, uiExperiments = _a.uiExperiments, se_clid = _a.se_clid;
    if (!session.sessionId) {
        var resp = new Response();
        resp.sentToTheVoid = true;
        return Promise.resolve(resp);
    }
    var dataToSubmit = __assign(__assign({}, session), { utm: utm, prefix: prefix, placement: placement, type: type, source: source, fields: combineAndSerializeTrackFields(fields, contextFields), feature: feature, referer: referer, name: name, amount: amount, count: count, items: items, message: message, channelStats: channelStats, featureFlags: featureFlags, uiExperiments: uiExperiments, se_clid: se_clid });
    return dataToSubmit;
}
function createZarazPayload(params, state) {
    var session = state.session, utm = state.utm, contextParams = state.contextParams, contextFields = state.contextFields;
    var _a = __assign(__assign({}, contextParams), params), product = _a.product, feature = _a.feature, name = _a.name, _b = _a.fields, fields = _b === void 0 ? [] : _b, placement = _a.placement, type = _a.type, source = _a.source, _c = _a.referer, referer = _c === void 0 ? getDefaultReferer() : _c, prefix = _a.prefix, amount = _a.amount, count = _a.count, items = _a.items, message = _a.message, channelStats = _a.channelStats, featureFlags = _a.featureFlags, uiExperiments = _a.uiExperiments, se_clid = _a.se_clid;
    var dataToSubmit = __assign(__assign({}, session), { product: product, utm: utm, prefix: prefix, placement: placement, type: type, source: source, feature: feature, referer: referer, name: name, amount: amount, count: count, items: items, message: message, channelStats: channelStats, featureFlags: featureFlags, se_clid: se_clid, abFlags: filterAndSerializeFeatureFlags(featureFlags), uiExperiments: arrToObject(uiExperiments || []), fields: Object.fromEntries(combineAndSerializeTrackFields(fields, contextFields)) });
    return dataToSubmit;
}
function filterAndSerializeFeatureFlags(featureFlags) {
    if (featureFlags === void 0) { featureFlags = {}; }
    return Object.entries(featureFlags)
        .filter(function (_a) {
        var _b = __read(_a, 2); _b[0]; var value = _b[1];
        return value === '1';
    })
        .map(function (_a) {
        var _b = __read(_a, 2), key = _b[0]; _b[1];
        return key;
    })
        .join(',');
}
function combineAndSerializeTrackFields(fields, contextFields) {
    return __spreadArray([], __read(new Map(__spreadArray(__spreadArray([], __read(fields), false), __read(contextFields.entries()), false))), false).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return [
            stringToSnakeCase(key),
            value === null || value === undefined ? value : "".concat(value),
        ];
    });
}

export { addContextFields, addContextParams, anonymize, identify, init, pulse, removeContextFields, setDebugMode, showDebugToast, stopPulsing, track };
